export enum DateFilterType {
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  LAST_MONTHS = 'lastMonths',
  WEEK_NUMBER = 'weekNumber',
  LAST_YEAR = 'lastYear'
}
